import { Button, Row, Col, Container, Modal } from "react-bootstrap";
import Select from "react-select";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useState, useEffect } from "react";
import HandleHttpErrors from "../../HandleHttpErrors";
import { useLocation, useNavigate } from "react-router-dom";
const baseURL = process.env.REACT_APP_API_JOBS;

const EditModal = ({
  showEdit,
  setShowEdit,
  examinee,
  increment,
  examineeStatus,
  setExamineeId,
  optionList,
}) => {
  const errorMessage = "Error";
  const header = "עדכון פרטי הנבחן";
  const [examinee1, setExaminee1] = useState({
    ...examinee,
    hakalaChanged: false,
  });
  const [error, setError] = useState(false);
  const [hakaloot, setHakaloot] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState();
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          "/jobs/HakalaReasonForExaminee?examinee_id=" + examinee1.id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setHakaloot(response.data);
          const hakalaOptions = response.data.map((item) => ({
            value: item.hakalareason,
            label: item.title,
          }));
          setSelectedOptions(hakalaOptions);
          console.log("hakaloot", response.data);
        }
      } catch (err) {
        if (err.response) {
          alert("הערה", HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name === "hakala_lang") {
      examinee1.hakala_lang = e.target.checked;
    } else if (name === "hakala_time") {
      examinee1.hakala_time = e.target.checked;
    } else {
      setExaminee1((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const saveData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "examinee/" + examinee1.id + "/",
          examinee1,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    saveData();
    // setDepart(null);
    setExamineeId(null);
    setError(false);
  };
  function handleSelect(data) {
    setSelectedOptions(data);
    setExaminee1((prevState) => ({
      ...prevState,
      hakalaChanged: true,
      ["hrfe_examinee"]: data,
    }));
  }
  return (
    <>
      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton={false}>
          <Modal.Title>
            <center>
              {"מספר הזמנה למבחן" + " " + examinee1.id}
              <br />
              {header + " " + examinee1.full_name + " " + examinee1.idz}{" "}
            </center>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <Container>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>מצב הנבחן</label>
                    <select
                      name="examinee_status"
                      onChange={handleChange}
                      value={examinee1.examinee_status}
                    >
                      <option key="0" value="" selected>
                        קבע מצב
                      </option>
                      {examineeStatus?.map((a) => (
                        <option key={a[0]} value={a[1]}>
                          {a[1]}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <div className="form-group">
                    <label>תאריך</label>
                    <input
                      type="date"
                      name="date"
                      className="form-control"
                      id="date"
                      value={examinee1.date}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label>מועד</label>
                    <input
                      type="time"
                      name="time"
                      className="form-control"
                      id="time"
                      value={examinee1.time}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <div className="form-group">
                    <label>הקלת שפה:</label>{" "}
                    <input
                      type="checkbox"
                      id="hakala_lang"
                      name="hakala_lang"
                      defaultChecked={examinee1.hakala_lang}
                      onChange={handleChange}
                    />
                  </div>
                </Col>

                <Col>
                  <div className="form-group">
                    <label>הקלת זמן:</label>{" "}
                    <input
                      type="checkbox"
                      id="hakala_time"
                      name="hakala_time"
                      defaultChecked={examinee1.hakala_time}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label>סיבות ההקלה</label>
                  <div className="dropdown-container">
                    <Select
                      options={optionList}
                      placeholder="בחר סיבות"
                      value={selectedOptions}
                      onChange={handleSelect}
                      isSearchable={true}
                      isMulti
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>הערות</label>
                    <textarea
                      name="notes"
                      className="form-control"
                      id="notes"
                      value={examinee1.notes}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleSubmit}
                  >
                    שמירה
                  </button>
                </div>
                <div className="col-lg-3"></div>
                <div className="col-lg-3">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      increment();
                      setShowEdit(false);
                      setExamineeId(null);
                    }}
                  >
                    סגירה
                  </Button>
                </div>
              </Row>
            </Container>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditModal;
